import { config } from "../../utils/constants";
import axios from "axios";

export const getPatientCertificates = () => {
  const requestConfig = {
    url: `${config.sickleaveServices}certificates`
  };

  return axios.request(requestConfig);
};

export const getQRCodeDetail = (encodeValue) => {
  const requestConfig = {
    url: `${config.sickleaveServices}qrcode?encode=${encodeValue}`
  };

  return axios.request(requestConfig);
};
export const getPatientCertificatesUrl = (id) => {
  const requestConfig = {
    url: `${config.sickleaveServices}certificates/url/${id}`
  };

  return axios.request(requestConfig);
};